import { motion } from "framer-motion";
import { DollarSign, Shield, ClipboardList, Truck } from "lucide-react";

const values = [
  {
    icon: DollarSign,
    title: "All-Inclusive Pricing",
    description:
      "Your one price includes ALL materials, installation, demolitions, underlayment, transitions, molding, furniture removal, shipping and tax. No hidden fees. No surprises.",
  },
  {
    icon: Shield,
    title: "Certified Installers",
    description:
      "Only highly trained and licensed installers work on your project. We never subcontract to unqualified workers — your home deserves the best.",
  },
  {
    icon: ClipboardList,
    title: "Simple 4-Step Process",
    description:
      "1. Introductory Call — 2. In-Home Measure — 3. Showroom Appointment — 4. Professional Installation. That's it. We make getting new floors easy.",
  },
  {
    icon: Truck,
    title: "Full-Service Experience",
    description:
      "From your first call to the final walkthrough, we handle everything. Furniture moving, old floor removal, and complete cleanup included.",
  },
];

const ValuesSection = () => {
  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">
            The MyNewFloor Difference
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mt-2 mb-4">
            Why Customers Choose Us
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We've reimagined the flooring buying experience to be simple, transparent, 
            and stress-free for every homeowner.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-background rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow text-center"
            >
              <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <value.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {value.title}
              </h3>
              <p className="text-muted-foreground text-sm">{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
